import { settingUserQueryOptions, useUpdateSettingUserMutation } from '@/api/settingUserOptions';
import { Checkbox, FormControlLabel, Typography } from '@mui/material';
import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_auth/settings')({
    component: SettingUserComponent,
})

function SettingUserComponent() {

    const settingUserQuery = useSuspenseQuery(
        settingUserQueryOptions()
    )
    const settingUser = settingUserQuery.data

    const updateSettingUserMutation = useUpdateSettingUserMutation()

    if (settingUserQuery.isLoading || settingUserQuery.isFetching) {
        return <div>Loading...</div>
    }

    return (
        <>
            <Typography variant="h6" gutterBottom>
                Einstellungen
            </Typography>
            <FormControlLabel control={
                <Checkbox checked={settingUser.showStartpage} onChange={(e) => {
                    if (e.target.checked) {
                        updateSettingUserMutation.mutate({ ...settingUser, showStartpage: true })
                    } else {
                        updateSettingUserMutation.mutate({ ...settingUser, showStartpage: false })
                    }
                }} />} label="Startseite nach dem Login anzeigen" />
            <br />
            <FormControlLabel control={
                <Checkbox checked={settingUser.reportAttachment} onChange={(e) => {
                    if (e.target.checked) {
                        updateSettingUserMutation.mutate({ ...settingUser, reportAttachment: true })
                    } else {
                        updateSettingUserMutation.mutate({ ...settingUser, reportAttachment: false })
                    }
                }} />} label="Berichte als Anhang versenden" />
        </>
    )
}